/**
 * phoneUtils.js - Telefon Numarası Doğrulama Aracı
 */

/**
 * Verilen telefon numarasının formatını doğrular.
 * Kural: 11 haneli ve "05" ile başlamalıdır.
 * @param {string} phone
 * @returns {boolean} Geçerliyse true, değilse false döner.
 */
export function validatePhone(phone) {
  if (!phone) return false;
  // Sadece rakamlardan oluşan, 11 haneli ve 05 ile başlayan
  const phoneRegex = /^05\d{9}$/;
  return phoneRegex.test(phone.trim());
}

export const PHONE_ERROR_MSG = "Geçersiz numara formatı. Lütfen 05 ile başlayan 11 haneli numaranızı girin.";
